import { render, staticRenderFns } from "./responsive-actions.vue?vue&type=template&id=9c880156&scoped=true&"
import script from "./responsive-actions.vue?vue&type=script&lang=js&"
export * from "./responsive-actions.vue?vue&type=script&lang=js&"
import style0 from "./responsive-actions.vue?vue&type=style&index=0&id=9c880156&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c880156",
  null
  
)

export default component.exports